<template>
  <div>
    <LoadingOverlay
      v-if="showLoader"
      :hasBlur="false"
      :isLight="true"
      visible
    />
    <div
      v-else
      :class="$style.fullHeight"
    >
      <ToolbarContainer v-if="!isNewAndroidApp">
        <template v-slot:toolbar>
          <nav>
            <div :class="$style.gridContainerOuter">
              <IconButton
                :class="$style.marginLeftSpacer"
                icon="add"
                iconPosition="left"
                :isDisabled="!isGoogleEmmEnrolled"
                text="Add New"
                type="primary"
                @click="handleAddNew"
              />
              <div :class="$style.gridItemOuter">
                <InputSearchFilter
                  :class="$style.filterHeight"
                  :disabled="isTableEmpty || !isGoogleEmmEnrolled"
                  placeholder="Search"
                  :value="searchTerm"
                  @apply="applyFilter"
                  @clearAll="clearAllFilter"
                  @updateSearchTerm="handleEnterSearchTerm"
                >
                  <template v-slot:content>
                    <SelectChipGroup
                      label="App Types:"
                      :options="filterOptions"
                      @input="updateDeviceFilter"
                    />
                  </template>
                </InputSearchFilter>
              </div>
              <div :class="$style.gridContainerInner">
                <MarkdownInline
                  :class="$style.gridItemInner"
                  :mdTemplate="manageSoftCount"
                />
                <Button
                  :class="$style.marginLeftSpacer"
                  :isDisabled="!showActions"
                  text="Delete"
                  textCase="capitalize"
                  @click="handleBulkDelete"
                />
                <IconButton
                  :class="$style.marginLeftSpacerSmall"
                  hasOutline
                  icon="refresh"
                  iconPosition="left"
                  :isDisabled="isTableEmpty || !isGoogleEmmEnrolled"
                  text="Refresh"
                  @click="handleRefresh"
                />
              </div>
            </div>
          </nav>
        </template>
        <template v-slot:body>
          <div v-if="!isTableEmpty && isGoogleEmmEnrolled">
            <ItemListPagination
              :class="$style.tableContainer"
              columnGap=""
              :columns="columns"
              :currentPageNum="0"
              :indeterminateSelectAll="indeterminateSelectAll"
              :isLoading="isListLoading"
              :itemComponent="$options.GoogleAppRow"
              :rowsPerPage="10"
              :selectAll="selectAll"
              selectable
              sortBy="organizationName"
              sortDirection="ascending"
              :tableData="tableData"
              :totalCount="totalCount"
              @pageChange="handlePageChange"
              @select="handleSelect"
              @selectAll="handleSelectAll"
            />
          </div>
          <div
            v-else
            :class="$style.playContainer"
          >
            <svg width="453" height="106" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.876 1.624C.685 2.904 0 4.874 0 7.434v91.063c0 2.56.685 4.53 1.92 5.766l.323.273 51.024-51.025v-1.146L2.198 1.352l-.322.272z" fill="url(#googleplay_svg__paint0_linear_1751_71684)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M70.24 70.587L53.22 53.562v-1.191l17.026-17.025.367.228L90.75 47.017c5.766 3.25 5.766 8.604 0 11.899L70.613 70.359c-.005 0-.373.228-.373.228z" fill="url(#googleplay_svg__paint1_linear_1751_71684)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M70.606 70.358L53.219 52.966 1.872 104.313c1.876 2.015 5.031 2.243 8.56.273l60.174-34.228z" fill="url(#googleplay_svg__paint2_linear_1751_71684)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M70.606 35.579L10.432 1.396C6.909-.62 3.748-.346 1.872 1.668l51.342 51.297L70.606 35.58z" fill="url(#googleplay_svg__paint3_linear_1751_71684)"/><path opacity=".2" fill-rule="evenodd" clip-rule="evenodd" d="M70.239 69.99l-59.763 33.956c-3.339 1.92-6.316 1.786-8.236.044l-.323.323.323.273c1.92 1.736 4.897 1.875 8.236-.045L70.65 70.358l-.411-.367z" fill="#000"/><path opacity=".12" fill-rule="evenodd" clip-rule="evenodd" d="M90.75 58.32L70.202 69.991l.368.367 20.135-11.442c2.883-1.648 4.302-3.796 4.302-5.95-.183 1.97-1.647 3.846-4.257 5.354z" fill="#000"/><path opacity=".25" fill-rule="evenodd" clip-rule="evenodd" d="M10.435 1.992l80.31 45.626c2.61 1.463 4.074 3.384 4.302 5.354 0-2.148-1.419-4.302-4.302-5.95L10.435 1.396C4.67-1.898 0 .846 0 7.435v.596c0-6.59 4.67-9.29 10.435-6.039z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M114.649 50.078c0-14.588 12.26-26.464 26.847-26.464 8.065 0 13.803 3.166 18.133 7.29l-5.098 5.098c-3.095-2.905-7.291-5.159-13.04-5.159-10.652 0-18.978 8.577-18.978 19.23 0 10.651 8.326 19.239 18.972 19.239 6.907 0 10.836-2.772 13.357-5.298 2.065-2.065 3.418-5.032 3.941-9.1h-17.287v-7.213h24.333c.256 1.291.389 2.839.389 4.514 0 5.415-1.486 12.132-6.266 16.913-4.653 4.842-10.586 7.425-18.461 7.425-14.593 0-26.854-11.866-26.854-26.464l.012-.011zm71.238-7.614c-9.423 0-17.114 7.168-17.114 17.036 0 9.817 7.686 17.036 17.114 17.036s17.102-7.23 17.102-17.042c0-9.867-7.68-17.035-17.102-17.03zm0 27.371c-5.159 0-9.617-4.257-9.617-10.33 0-6.133 4.452-10.329 9.617-10.329 5.159 0 9.611 4.19 9.611 10.33 0 6.066-4.447 10.33-9.611 10.33zm37.316-27.371c-9.422 0-17.102 7.168-17.102 17.036 0 9.817 7.68 17.036 17.102 17.036 9.423 0 17.103-7.23 17.103-17.042 0-9.867-7.675-17.035-17.103-17.03zm0 27.371c-5.159 0-9.617-4.257-9.617-10.33 0-6.133 4.452-10.329 9.617-10.329 5.159 0 9.617 4.19 9.617 10.33 0 6.066-4.458 10.33-9.617 10.33zM269.002 43.5v2.772h-.256c-1.676-2.01-4.904-3.813-8.966-3.813-8.521 0-16.341 7.492-16.341 17.114 0 9.545 7.814 16.975 16.341 16.975 4.062 0 7.29-1.803 8.966-3.868h.256v2.449c0 6.517-3.484 10.007-9.1 10.007-4.586 0-7.424-3.295-8.588-6.061l-6.522 2.71c1.87 4.514 6.845 10.068 15.104 10.068 8.772 0 16.196-5.17 16.196-17.754V43.494l-7.09.005zm-8.582 26.336c-5.16 0-9.495-4.33-9.495-10.263 0-6 4.33-10.39 9.495-10.39 5.098 0 9.099 4.385 9.099 10.39.006 5.933-3.996 10.263-9.099 10.263zm20.842-44.412h7.491v50.089h-7.491v-50.09zm28.023 44.412c-3.807 0-6.523-1.747-8.254-5.16l22.785-9.433-.785-1.936c-1.413-3.802-5.743-10.842-14.587-10.842-8.777 0-16.073 6.907-16.073 17.041 0 9.545 7.23 17.036 16.914 17.036 7.813 0 12.333-4.77 14.203-7.552l-5.811-3.868c-1.942 2.844-4.591 4.72-8.392 4.714zm-.585-20.787c2.967 0 5.482 1.486 6.322 3.612l-15.238 6.328c-.189-6.584 5.104-9.94 8.916-9.94zM356.687 25.422h-17.91v50.09h7.475V56.539h10.44c8.287 0 16.435-6 16.435-15.561 0-9.545-8.142-15.55-16.423-15.55l-.017-.006zm.195 24.143h-10.63V32.39h10.63c5.587 0 8.771 4.636 8.771 8.588 0 3.885-3.184 8.587-8.771 8.587zm27.838 25.947v-50.09h-7.474v50.09h7.474zm33.577-.09v-19.2c0-8.894-6.646-13.853-15.222-13.853-5.404 0-11.008 2.388-13.329 7.67l6.634 2.765c1.419-2.766 4.057-3.673 6.834-3.673 3.863 0 7.792 2.321 7.853 6.45v.518c-1.352-.773-4.246-1.936-7.797-1.936-7.152 0-14.431 3.929-14.431 11.275 0 6.707 5.866 11.02 12.438 11.02 5.032 0 7.798-2.254 9.534-4.892h.256v3.868h7.224l.006-.011zm-16.112-5.598c-2.449 0-5.866-1.225-5.866-4.247 0-3.868 4.257-5.36 7.93-5.36 3.29 0 4.831.708 6.835 1.676a9.082 9.082 0 01-8.899 7.93zm42.397-26.358l-8.57 21.71h-.256l-8.894-21.71h-8.053l13.335 30.354-7.608 16.88h7.797l20.553-47.234h-8.304z" fill="#808285"/><defs><linearGradient id="googleplay_svg__paint0_linear_1751_71684" x1="48.685" y1="6.456" x2="-33.047" y2="28.233" gradientUnits="userSpaceOnUse"><stop stop-color="#00A0FF"/><stop offset=".007" stop-color="#00A1FF"/><stop offset=".26" stop-color="#00BEFF"/><stop offset=".512" stop-color="#00D2FF"/><stop offset=".76" stop-color="#00DFFF"/><stop offset="1" stop-color="#00E3FF"/></linearGradient><linearGradient id="googleplay_svg__paint1_linear_1751_71684" x1="98.252" y1="52.969" x2="-1.403" y2="52.969" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE000"/><stop offset=".409" stop-color="#FFBD00"/><stop offset=".775" stop-color="orange"/><stop offset="1" stop-color="#FF9C00"/></linearGradient><linearGradient id="googleplay_svg__paint2_linear_1751_71684" x1="61.151" y1="62.428" x2="-4.463" y2="172.862" gradientUnits="userSpaceOnUse"><stop stop-color="#FF3A44"/><stop offset="1" stop-color="#C31162"/></linearGradient><linearGradient id="googleplay_svg__paint3_linear_1751_71684" x1="-11.053" y1="-28.668" x2="18.22" y2="20.654" gradientUnits="userSpaceOnUse"><stop stop-color="#32A071"/><stop offset=".069" stop-color="#2DA771"/><stop offset=".476" stop-color="#15CF74"/><stop offset=".801" stop-color="#06E775"/><stop offset="1" stop-color="#00F076"/></linearGradient></defs></svg>
            <div
              v-if="isGoogleEmmEnrolled"
              :class="[$style.marginTop, $style.alignCenter]"
            >
              <HeadingLarge>
                {{ addNewAppText.title }}
              </HeadingLarge>
              <ParagraphBody>
                <div>{{ addNewAppText.clickToAddNew }}</div>
                <div>{{ addNewAppText.manageDevice }}</div>
              </ParagraphBody>
            </div>
            <div
              v-else
              :class="[$style.marginTop, $style.alignCenter]"
            >
              <HeadingLarge>
                {{ addNewAppText.welcomeText }}
              </HeadingLarge>
              <ParagraphBody>
                <div>{{ addNewAppText.getYourSetup }}</div>
                <div>{{ addNewAppText.releatedTo }}</div>
                <div>{{ addNewAppText.assign }}</div>
              </ParagraphBody>
              <Button
                :class="$style.marginTop"
                text="Let's Do it!"
                textCase="capitalize"
                @click="handleEmmEnrollment"
              />
            </div>
          </div>
          <DeleteModal
            :actionItem="data"
            :primaryButtonProps="primaryButtonProps"
            :showModal="showModal"
            @handleClose="handleCancellation"
            @handleSave="handleConfirmation"
          />
        </template>
      </ToolbarContainer>
      <AddNewGoogleApp
        v-else
        :class="$style.fullHeight"
        :isNewAndroidApp="isNewAndroidApp"
        @configureComplete="handleConfigureComplete"
      />
    </div>
  </div>
</template>

<script>
import {
  AndroidEmmConsts, ItemTypeConsts, ItemTypeRoutes, StoreModuleMap,
} from 'client/util/Constants';
import {
  Button,
  HeadingLarge,
  IconButton,
  InputSearchFilter,
  ItemListPagination,
  LoadingOverlay,
  MarkdownInline,
  ParagraphBody,
  SelectChipGroup,
  ToolbarContainer,
  Types,
} from '@jumpcloud/ui-components';
import { mapActions, mapState } from 'vuex';
import AddNewGoogleApp from 'client/SoftwareApps/AddNewGoogleApp.vue';
import DeleteModal from 'client/SoftwareApps/DeleteModal.vue';
import GoogleAppRow from 'client/SoftwareApps/GoogleAppRow.vue';
import SoftwareAppsApi from 'client/api/v2/SoftwareAppsApi';
import Util from 'client/util/Util';
import Vue from 'vue';
import moment from 'moment/moment';

const googleModule = StoreModuleMap[ItemTypeConsts.mdmGoogle];
const { Column, PrimaryButtonProps } = Types;
const softwareAppsCollection = StoreModuleMap[ItemTypeConsts.softwareApps];
const appColumns = [
  Column({
    dataFieldName: 'organizationName',
    label: 'Name',
    sortable: false,
    width: '',
    visible: true,
  }),
  Column({
    dataFieldName: 'applicationType',
    label: 'Application Type',
    sortable: false,
    width: '',
    visible: true,
  }),
  Column({
    dataFieldName: 'commandStatus',
    label: 'Command Status',
    sortable: false,
    width: '',
    visible: true,
  }),
];

export default {
  name: 'GoogleAppsItemTable',

  components: {
    AddNewGoogleApp,
    Button,
    DeleteModal,
    HeadingLarge,
    IconButton,
    InputSearchFilter,
    ItemListPagination,
    LoadingOverlay,
    MarkdownInline,
    ParagraphBody,
    SelectChipGroup,
    ToolbarContainer,
  },

  data() {
    return {
      addNewAppText: AndroidEmmConsts.addAndroidAppText,
      appliedFilterOnSelectedStateChips: [],
      columns: appColumns,
      currentPageNum: 0,
      data: [],
      filterOptions: [{ name: 'Public', value: 'PUBLIC' }, { name: 'Private', value: 'PRIVATE' }, { name: 'Web', value: 'WEB' }],
      filteredData: [],
      filteredByData: [],
      indeterminateSelectAll: false,
      isListLoading: false,
      routeApps: `/${ItemTypeRoutes[ItemTypeConsts.softwareApps]}`,
      routeEMM: `/${ItemTypeRoutes[ItemTypeConsts.mdmSettings]}`,
      rowsPerPage: 10,
      tableData: [],
      origData: [],
      totalCount: 0,
      enterpriseRspBody: null,
      selectedStateChips: [],
      searchTerm: '',
      search: false,
      selectAll: false,
      showLoader: true,
      showModal: false,
      showActions: false,
    };
  },

  GoogleAppRow,

  computed: {
    ...mapState(googleModule, [
      'isGoogleEmmEnrolled',
      'isNewAndroidApp',
    ]),

    isTableEmpty() {
      return this.tableData.length === 0;
    },

    manageSoftCount() {
      return `**${this.data.length} managed software packages**`;
    },

    primaryButtonProps() {
      return PrimaryButtonProps({
        isDisabled: false,
        text: 'Delete',
        type: 'primary',
      });
    },
  },

  created() {
    this.fetchEnrollment();
  },

  mounted() {
    const gapiScript = document.createElement('script');
    gapiScript.setAttribute('src', 'https://apis.google.com/js/api.js');
    document.head.appendChild(gapiScript);
    this.fetchApps();
    this.updateAddNewAppState(false);
  },

  methods: {
    ...mapActions(googleModule, [
      'getEnterprise',
      'updateEnrollState',
      'updateGoogleEmmEnterpriseObjState',
      'updateAddNewAppState',
    ]),

    ...mapActions(softwareAppsCollection, [
      'deleteItems',
    ]),

    applyFilter() {
      this.appliedFilterOnSelectedStateChips = this.selectedStateChips;
      this.currentPageNum = 0;
      const chipsStateNameArr = this.selectedStateChips.map((chip) => chip.name);
      let copiedData = this.data;
      if (this.searchTerm) {
        copiedData = this.filteredByData;
      }

      const filteredObj = {};
      if (chipsStateNameArr.length) {
        filteredObj.applicationType = chipsStateNameArr;
      }
      if (Object.keys(filteredObj).length) {
        this.filteredData = copiedData.filter((data) => {
          if (Object.keys(filteredObj).every((el) => filteredObj[el].includes(data[el]))) {
            return data;
          }
          return null;
        });
      } else {
        this.clearAllFilter();
        return;
      }

      this.totalCount = this.filteredData.length;
      const start = this.currentPageNum * this.rowsPerPage;
      const end = start + this.rowsPerPage;
      this.totalCount = this.filteredData.length;
      this.tableData = this.filteredData.slice(start, end);
    },

    clearAllFilter() {
      this.filteredData = [];
      this.appliedFilterOnSelectedStateChips = [];
      this.selectedStateChips = [];
      if (this.searchTerm) {
        this.handleEnterSearchTerm(this.searchTerm);
        return;
      }
      this.currentPageNum = 0;
      const start = this.currentPageNum * this.rowsPerPage;
      const end = start + this.rowsPerPage;
      this.totalCount = this.data.length;
      this.tableData = this.data.slice(start, end);
    },

    async fetchApps() {
      const filters = [{
        name: 'packageManager',
        operator: 'eq',
        value: 'GOOGLE_ANDROID',
      }];
      let apiData;
      this.origData = [];
      this.data = [];
      this.tableData = [];
      this.isListLoading = true;
      this.maxFetchLimit = 100;
      this.totalCount = await SoftwareAppsApi.fetchTotalCount();
      const callApi = (page = 0) => SoftwareAppsApi.fetchAll(
        page * this.maxFetchLimit,
        this.maxFetchLimit,
        filters,
      );
      const firstRequest = callApi();

      await firstRequest
        .then((response) => {
          if (this.totalCount > this.maxFetchLimit) {
            const requests = [firstRequest];
            for (; this.totalCount > this.maxFetchLimit; this.totalCount -= this.maxFetchLimit) {
              requests.push(callApi(requests.length));
            }
            return Promise.all(requests).then((responses) => responses
              .map((resp) => resp)
              .reduce((all, data) => all.concat(data), []));
          }
          return response;
        })
        .then((apps) => {
          apiData = apps;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isListLoading = false;
          this.showLoader = false;
        });
      this.origData = apiData;
      this.origData = this.origData.map((item) => ({
        id: item.id,
        organizationName: item.displayName,
        iconUrl: item.settings[0].googleAndroid.iconUrl,
        applicationType: this.formatType(item.settings[0].googleAndroid.type),
        commandStatus: '',
      }));

      this.data = this.origData;
      const obj = this.data.filter((o) => o.selected === true);
      if (obj.length !== this.data.length && this.selectAll) {
        this.selectAll = false;
        this.indeterminateSelectAll = true;
      } else if (obj.length === this.data.length && this.selectAll) {
        this.selectAll = true;
        this.indeterminateSelectAll = false;
      } else if (obj.length === 0) {
        this.selectAll = false;
        this.indeterminateSelectAll = false;
      }
      let start = 0;
      let end = start + 10;
      if (this.data.length) {
        start = (0) * 10;
        end = start + 10;

        this.currentPageNum -= 1;
        this.tableData = this.data.slice(start, end);
      } else {
        this.currentPageNum = 0;
      }
    },

    async fetchEnrollment() {
      try {
        const enterpriseResponse = await this.getEnterprise();
        if (enterpriseResponse.count > 0) {
          const resIndex = enterpriseResponse.count - 1;
          const [enterpriseName, clientId] = enterpriseResponse.enterprises[resIndex].name.split('/');
          this.enterpriseRspBody = {
            clientId,
            enterpriseEmail: '',
            createdAt: moment(enterpriseResponse.enterprises[resIndex].createdAt).format('MMMM d, YYYY, h:mm A'),
            enterpriseName,
            enterpriseObjectId: enterpriseResponse.enterprises[resIndex].objectId,
            organizationObjectId: enterpriseResponse.enterprises[resIndex].organizationObjectId,
            allowDeviceEnrollment: enterpriseResponse.enterprises[resIndex].allowDeviceEnrollment
              ? enterpriseResponse.enterprises[resIndex].allowDeviceEnrollment
              : false,
          };
          this.updateGoogleEmmEnterpriseObjState(this.enterpriseRspBody);
          this.updateEnrollState(true);
        } else {
          this.updateEnrollState(false);
          this.showLoader = false;
        }
      } catch (e) {
        this.updateEnrollState(false);
        this.showLoader = false;
      }
    },

    formatType(value) {
      let formattedValue = value;
      if (formattedValue === 'WEBAPP') {
        formattedValue = 'WEB';
      }
      const updatedValue = formattedValue.toLowerCase();
      return updatedValue.charAt(0).toUpperCase() + updatedValue.slice(1);
    },

    handleAddNew() {
      this.updateAddNewAppState(true);
      Util.redirect(`${this.routeApps}/google/new`);
    },

    async handleBulkDelete() {
      this.showModal = true;
    },

    handleCancellation() {
      this.showModal = false;
    },

    async handleConfigureComplete() {
      await this.fetchApps();
    },

    async handleConfirmation() {
      this.showModal = false;
      this.selectedIds = [];
      const itemIds = this.data.filter((item) => item.selected === true);
      itemIds.forEach((itemId) => {
        this.selectedIds.push(itemId.id);
      });
      // should show modal
      await this.deleteItems(this.selectedIds);
      this.handleRefresh();
    },

    handleEmmEnrollment() {
      Util.redirect(`${this.routeEMM}/google`);
    },

    async handleEnterSearchTerm(searchTerm) {
      if (searchTerm.length && !searchTerm.trim().length) return;
      this.searchTerm = searchTerm;
      this.shouldFocusSearch = false;
      this.currentPageNum = 0;
      const searchColumns = ['organizationName'];

      const intermediateData = [...this.data];
      this.filteredByData = intermediateData.filter((user) => {
        if (Object.keys(user)
          .some((key) => searchColumns.includes(key) && (`${user[key]}`).toLowerCase().includes(this.searchTerm.toLowerCase()))) {
          return user;
        }
        return null;
      });
      if (this.searchTerm !== '') {
        this.search = true;
      } else {
        this.search = false;
      }

      const start = this.currentPageNum * this.rowsPerPage;
      const end = start + this.rowsPerPage;
      this.totalCount = this.filteredByData.length;
      this.tableData = this.filteredByData.slice(start, end);
    },

    handlePageChange(paginationData) {
      this.isListLoading = true;
      if (paginationData) {
        const { currentPageNum, rowsPerPage } = paginationData;
        this.currentPageNum = currentPageNum;
        this.rowsPerPage = rowsPerPage;
      }
      const start = this.currentPageNum * this.rowsPerPage;
      const end = start + this.rowsPerPage;
      if (!this.isAnyFilterApplied && this.search) {
        this.tableData = this.filteredByData.slice(start, end);
      } else if (this.isAnyFilterApplied) {
        this.tableData = this.filteredData.slice(start, end);
      } else {
        this.tableData = this.data.slice(start, end);
      }

      /** The header checkbox should be set to
      selectAll or indeterminateSelectAll based on this.tableData
      * */
      let itemSelectedCount = 0;
      this.tableData.forEach((element) => {
        if (element.selected === true) {
          itemSelectedCount += 1;
        }
      });

      if (itemSelectedCount === this.tableData.length) {
        this.indeterminateSelectAll = false;
        this.selectAll = true;
      } else if (itemSelectedCount > 0) {
        this.selectAll = false;
        this.indeterminateSelectAll = true;
      } else {
        this.selectAll = false;
        this.indeterminateSelectAll = false;
      }

      this.isListLoading = false;
    },

    async handleRefresh() {
      await this.fetchApps();
    },

    handleSelect(selectedItem) {
      const foundDataIndex = this.data.findIndex((item) => item.id === selectedItem.id);
      const selectedItemValue = this.data[foundDataIndex];
      const newValue = {
        ...selectedItemValue,
        selected: !selectedItemValue.selected,
      };
      Vue.set(this.data, foundDataIndex, newValue);

      const foundTableDataIndex = this.tableData.findIndex((item) => item.id === selectedItem.id);
      const selectedTableDataValue = this.tableData[foundTableDataIndex];
      const newTableValue = {
        ...selectedTableDataValue,
        selected: !selectedTableDataValue.selected,
      };
      Vue.set(this.tableData, foundTableDataIndex, newTableValue);

      if (this.selectAll && !this.indeterminateSelectAll) {
        this.selectAll = false;
      }

      const selectedItemIndex = this.data.findIndex((item) => item.selected === true);
      const foundSelectedItem = selectedItemIndex >= 0;
      this.showActions = foundSelectedItem;
      this.indeterminateSelectAll = foundSelectedItem;
    },

    handleSelectAll(value) {
      let selectedItems = [];
      if (this.search) {
        selectedItems = this.tableData.map((item) => ({
          ...item,
          selected: value,
        }));

        this.tableData = selectedItems;
        this.tableData.forEach((element) => {
        // Updating the tableData in filtered data and data
          const selectedItemIndex = this.filteredData.findIndex((item) => item.id === element.id);
          Vue.set(this.filteredData, selectedItemIndex, element);
          const selectedDataItemIndex = this.data.findIndex((item) => item.id === element.id);
          Vue.set(this.data, selectedDataItemIndex, element);
        });
      } else {
        selectedItems = this.tableData.map((item) => ({
          ...item,
          selected: value,
        }));
        this.tableData = selectedItems;

        this.tableData.forEach((element) => {
        // Updating the tableData in data
          const selectedItemIndex = this.data.findIndex((item) => item.id === element.id);
          Vue.set(this.data, selectedItemIndex, element);
        });
      }

      this.selectAll = true;
      this.showActions = value && this.data.length;
      this.indeterminateSelectAll = false;
    },

    updateDeviceFilter(filters) {
      filters.forEach(filter => {
        this.selectedStateChips.push(filter);
      });
    },
  },
};
</script>

<style module>
.gridContainerOuter {
  display: flex;
  margin-bottom: 0.75rem;
  margin-top: 0.75rem;
}

.gridContainerInner {
  display: flex;
  flex-wrap: wrap;
  margin-left: var(--jc-spacer);
  margin-right: var(--jc-spacer);
}

.gridItemOuter {
  flex: 1 1 auto;
  margin-left: var(--jc-spacer);
}

.gridItemInner {
  align-items: center;
  display: flex;
  justify-content: center;
}

.playContainer {
  align-items: center;
  background-color: var(--jc-color-background);
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.tableContainer {
  padding: var(--jc-spacer-small);
}

.marginLeftSpacer.marginLeftSpacer {
  margin-left: var(--jc-spacer);
}

.marginLeftSpacerSmall {
  margin-left: var(--jc-spacer-small);
}

.marginTop {
  margin-top: var(--jc-spacer-large);
}

.alignCenter {
  text-align: center;
}

.fullHeight {
  height: 100%;
}

.filterHeight {
  margin-left: var(--jc-spacer-x-small);
}

.filterHeight > div > div:nth-child(2) > div > div:nth-child(2) {
  min-height: 6.375rem;
}
</style>
